/** This must be an odd number. Will render fewer pages at the beginning or end. */
const MAX_PAGES_TO_RENDER_AT_ONCE = 3;

export function shouldRenderThisPage(args: {
  /** 1-based index of the page that the user is currently looking at */
  currentlyVisiblePageIndex: number;
  /** 1-based index of this page relative to all other pages in all other documents */
  crossDocPageIndex: number;
}) {
  const { currentlyVisiblePageIndex: visible, crossDocPageIndex: index } = args;
  const range = (MAX_PAGES_TO_RENDER_AT_ONCE + 1) / 2; // This is unintuitive but the math checks out
  return visible - range < index && index < visible + range;
}
